import * as React from "react";
import {
    IAge,
    IMonthYear,
    IPensionAgeCalculationResult,
    PensionAgeCalculatorService,
} from "../Services/PensionAgeCalculatorService";
import Age from "./Age";
import YearMonth from "./YearMonth";

export interface IPensionCalculationResultProps {
    birthYear: number;
    birthMonth: number;
    sourceFileId: string;
    estimationsStart: number;
    estimationsLabel: string;
    yearsLabel: string;
    monthsLabel: string;
    lowestAgeLabel: string;
    targetAgeLabel: string;
    latestAgeLabel: string;
    dateLabel: string;
}

interface IPensionCalculationResultState extends IPensionAgeCalculationResult {}

// tslint:disable-next-line:max-classes-per-file
export class PensionCalculationResult extends React.Component<
    IPensionCalculationResultProps,
    IPensionCalculationResultState
> {
    private calculatorService: PensionAgeCalculatorService;

    constructor(props: Readonly<IPensionCalculationResultProps>) {
        super(props);
        this.state = {
            birthTime: null,
            latestDate: null,
            lowestAge: null,
            lowestDate: null,
            maximumAge: null,
            targetAge: null,
            targetDate: null,
        };
        this.calculatorService = new PensionAgeCalculatorService(this.props.sourceFileId);
    }

    public componentDidMount(): void {
        this.fetchTargetAges(this.props.birthYear, this.props.birthMonth);
    }

    public componentDidUpdate(prevProps: Readonly<IPensionCalculationResultProps>): void {
        if (this.props.birthMonth === prevProps.birthMonth && this.props.birthYear === prevProps.birthYear) {
            return;
        }
        this.fetchTargetAges(this.props.birthYear, this.props.birthMonth);
    }

    public render() {
        if (this.state.birthTime === null) {
            return <div />;
        }
        return (
            <div>
                <div className={"result-section"}>
                    <div>{this.props.lowestAgeLabel}</div>
                    {this.renderAge(this.state.lowestAge)}. {this.renderDate(this.state.lowestDate)}.
                </div>
                { this.state.targetAge.years > -1 && <div className={"result-section"}>
                                                            <div>{this.props.targetAgeLabel}</div>
                                                            {this.renderAge(this.state.targetAge)}. {this.renderDate(this.state.targetDate)}.
                                                        </div>
                }
               
                {this.renderMaximumAge()}
                {this.props.estimationsStart <= this.state.birthTime.year && (
                    <div className={"is-estimation"}>{this.props.estimationsLabel}</div>
                )}
            </div>
        );
    }

    private renderAge(age: IAge) {
            return (
                <Age
                    yearsLabel={this.props.yearsLabel}
                    monthsLabel={this.props.monthsLabel}
                    years={age.years}
                    months={age.months}
                />
            );
        
    }

    private renderDate(date: IMonthYear) {
        return (
            <span>
                {this.props.dateLabel} <YearMonth year={date.year} month={date.month} />
            </span>
        );
    }

    private renderMaximumAge() {
        if (this.state.maximumAge.years > -1 && this.state.maximumAge.years > this.state.targetAge.years) {
            return (
                <div className={"result-section"}>
                    <div>{this.props.latestAgeLabel}</div>
                    {this.renderAge(this.state.maximumAge)}. {this.renderDate(this.state.latestDate)}.
                </div>
            );
        } else {
            return "";
        }
    }

    private fetchTargetAges(birthYear: number, birthMonth: number) {
        /*
        Local version of debounce. Only fetch data after 500ms has passed and we don't have new props by then.
        This is to only get results once when users uses the slider. Without this the last returned result is shown to
        user, and that might not be the last selected value.
         */
        setTimeout(() => {
            if (this.props.birthMonth !== birthMonth || this.props.birthYear !== birthYear) {
                return;
            }
            this.calculatorService
                .getPensionTargets(birthYear, birthMonth)
                .then((data: IPensionAgeCalculationResult) => {
                    this.setState(data as IPensionCalculationResultState);
                })
                .catch((reason: any) => {
                    // tslint:disable-next-line:max-line-length
                    console.error(
                        `Error while loading pension ages with birth year: ${birthYear} and birth month: ${birthMonth}`,
                    );
                    console.error(reason);
                });
        }, 500);
    }
}

export default PensionCalculationResult;
